// extracted by mini-css-extract-plugin
module.exports = {"body":"searchbar-module--body--2xFjW","typeahead":"searchbar-module--typeahead--3dgiz","typeahead2":"searchbar-module--typeahead2--xGJAE"};